module.exports = __webpack_public_path__ + "static/media/logo.cbe2d908.svg";